import { defineMessages } from 'react-intl';

const messages = defineMessages({
  ArtistRecommendationHeading: {
    defaultMessage: 'Artists to follow',
    description: 'Heading for artist recommendations.'
  }
});

export default messages;
